export default __webpack_public_path__ + "static/assets/63edd39e6afe6627d8e6e8db62bff5a1.svg";